export default __webpack_public_path__ + "static/prescriber2-f9946b65803f532e8185312657400faf.webp";